export enum Role {
    ADMINISTRATOR,
    SUPERVISOR,
    DEVELOPER,
    AGENT
}